import _omit from 'lodash.omit';
import { getLocalStorage, setLocalStorage } from './storage';

function deleteAssetFromLocalStorage(assetId) {
  const localStorage = getLocalStorage();

  setLocalStorage(_omit(localStorage, [assetId]));
}

export default deleteAssetFromLocalStorage;